export const fr_chatDetails = {
  heading: 'Détails chat',
  chatTooltip: "Le portail affiche jusqu'à 6 mois de données",
  createdOn: {
    label: 'Créé',
    info: 'Lorsque le chat a été lancé dans notre système.'
  },
  pickedUpOn: {
    label: 'Ramassée',
    info: 'Quand le chat a été ramassé sur.'
  },
  pickedUpBy: {
    label: 'Ramassé par',
    info: 'Qui a pris le chat.'
  },
  endedOn: {
    label: 'Terminé',
    info: 'Quand le chat a pris fin dans notre système.'
  },
  leadFlag: {
    label: 'Drapeau plomb',
    info: 'Si la conversation dans le chat transformé en une avance valide.'
  },
  ip: {
    label: 'IP',
    info: "L'IP où le chat a commencé."
  },
  location: {
    label: 'Emplacement',
    info: "L'emplacement du visiteur."
  },
  referrer: {
    label: 'Référent',
    info: 'Le referrer où le chat a été lancé.'
  },
  chatTranscript: {
    label: 'Transcription du chat',
    info: 'Transcription du chat'
  }
};
export default fr_chatDetails;
